export default [
  {
    title: 'Home',
    icon: 'HomeIcon',
    route: 'dashboard-analytics',
  },
]
